import React from 'react';
import apiURLs from '../99_untils/apiURLs';
import { openUrl } from '../99_untils/flutterCallback';
import { useTranslation } from 'react-i18next';
import '../99_untils/i18n';
import './HomeBanner.css';
import exoEvent1Icon from '../Home/images/exo-event1.png';
import exoEvent2Icon from '../Home/images/exo-event2.png';
import exoEvent3Icon from '../Home/images/exo-event3.png';

export default function HomeBanner() {
  const { t, i18n } = useTranslation();
  const curLang = i18n.language;

  return (
    <div className="exo-events-wrap">
      <div className="exo-events-header">
        <h2 className="exo-events-title">{t('exoEventTitle')}</h2>
        <p className="exo-events-subtitle">
          {t('exoEventSubtitlePart1')}{curLang === 'zh-HK' && <br />}<span className="exo-events-subtitle-nowrap">{t('exoEventSubtitlePart2')}</span>
        </p>
        <hr className="exo-events-divider" />
      </div>

      <div className="exo-event-item">
        <h4 className="exo-event-item-title">{t('exoEvent1TitlePrefix')}<span className="event-title-nowrap">{t('exoEvent1TitleMain')}</span></h4>
        <p className="exo-event-item-content">{t('exoEvent1Content')}</p>
        <div className="exo-event-icon"><img src={exoEvent1Icon} alt="event 1 icon" /></div>
      </div>

      <div className="exo-event-item">
        <h4 className="exo-event-item-title">{t('exoEvent2TitlePrefix')}<span className="event-title-nowrap">{t('exoEvent2TitleMain')}</span></h4>
        <p className="exo-event-item-content">{t('exoEvent2Content')}</p>
        <div className="exo-event-icon"><img src={exoEvent2Icon} alt="event 2 icon" /></div>
      </div>

      <div className="exo-event-item">
        <h4 className="exo-event-item-title">{t('exoEvent3TitlePrefix')}<span className="event-title-nowrap">{t('exoEvent3TitleMain')}</span></h4>
        <p className="exo-event-item-content">{t('exoEvent3Content')}</p>
        <div className="exo-event-icon"><img src={exoEvent3Icon} alt="event 3 icon" /></div>
      </div>

      <div className="exo-events-buttons">
        <button className="exo-events-btn" onClick={() => window.open('https://l.d-ash.com/p0cu2?tag=twiceweb', '_blank')}>{t('exoBtnDownloadDash')}</button>
        <button className="exo-events-btn" onClick={() => openUrl(apiURLs.goToJooxUrl, apiURLs.goToJooxUrl)}>{t('exoBtnGoToJoox')}</button>
      </div>

      <p className="exo-events-terms">{t('exoTermsText')}</p>
    </div>
  );
}

